import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-base',
    template: `
    `,
    styles: [],
    standalone: false
})

export class BaseComponent implements OnInit {
    constructor(
        public translate: TranslateService
    ) {
        translate.setDefaultLang('en-GB');
        translate.use('en-GB');
    }
    ngOnInit(): void {

    }
}
